import axios from "axios";
import { server } from "../../server";

// Admin: Get all vendor applications
export const getVendorApplications = (status, page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getVendorApplicationsRequest" });
    let url = `${server}/vendor/admin-vendor-applications?page=${page}`;
    if (status) url += `&status=${status}`;
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({ type: "getVendorApplicationsSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getVendorApplicationsFailed", payload: error.response?.data?.message });
  }
};

// Admin: Approve vendor
export const approveVendor = (vendorId) => async (dispatch) => {
  try {
    dispatch({ type: "approveVendorRequest" });
    const { data } = await axios.put(
      `${server}/vendor/admin-approve-vendor/${vendorId}`,
      {},
      { withCredentials: true }
    );
    dispatch({ type: "approveVendorSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "approveVendorFailed", payload: error.response?.data?.message });
  }
};

// Admin: Reject vendor
export const rejectVendor = (vendorId, reason) => async (dispatch) => {
  try {
    dispatch({ type: "rejectVendorRequest" });
    const { data } = await axios.put(
      `${server}/vendor/admin-reject-vendor/${vendorId}`,
      { reason },
      { withCredentials: true }
    );
    dispatch({ type: "rejectVendorSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "rejectVendorFailed", payload: error.response?.data?.message });
  }
};

// Admin: Approve product with pricing
export const adminApproveProduct = (productId, priceData) => async (dispatch) => {
  try {
    dispatch({ type: "adminApproveProductRequest" });
    const { data } = await axios.put(
      `${server}/vendor/admin-approve-product/${productId}`,
      priceData,
      { withCredentials: true }
    );
    dispatch({ type: "adminApproveProductSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "adminApproveProductFailed", payload: error.response?.data?.message });
  }
};

// Admin: Reject product
export const adminRejectProduct = (productId, reason) => async (dispatch) => {
  try {
    dispatch({ type: "adminRejectProductRequest" });
    const { data } = await axios.put(
      `${server}/vendor/admin-reject-product/${productId}`,
      { reason },
      { withCredentials: true }
    );
    dispatch({ type: "adminRejectProductSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "adminRejectProductFailed", payload: error.response?.data?.message });
  }
};

// Admin: Set product pricing
export const adminSetPrice = (productId, priceData) => async (dispatch) => {
  try {
    dispatch({ type: "adminSetPriceRequest" });
    const { data } = await axios.put(
      `${server}/vendor/admin-set-price/${productId}`,
      priceData,
      { withCredentials: true }
    );
    dispatch({ type: "adminSetPriceSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "adminSetPriceFailed", payload: error.response?.data?.message });
  }
};

// Admin: Get pending products
export const getPendingProducts = (page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getPendingProductsRequest" });
    const { data } = await axios.get(
      `${server}/vendor/admin-pending-products?page=${page}`,
      { withCredentials: true }
    );
    dispatch({ type: "getPendingProductsSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getPendingProductsFailed", payload: error.response?.data?.message });
  }
};

// Admin: Get vendor payment summary
export const getVendorPaymentSummary = () => async (dispatch) => {
  try {
    dispatch({ type: "getVendorPaymentSummaryRequest" });
    const { data } = await axios.get(`${server}/vendor/admin-vendor-payment-summary`, {
      withCredentials: true,
    });
    dispatch({ type: "getVendorPaymentSummarySuccess", payload: data.summary });
  } catch (error) {
    dispatch({ type: "getVendorPaymentSummaryFailed", payload: error.response?.data?.message });
  }
};
